import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const PageTitle = ({ motherMenu, activeMenu, motherMenuPath = "/" }) => {
  const { t } = useTranslation();

  return (
    <div className="page-titles mb-4">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-primary">{t(activeMenu)}</h5>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={motherMenuPath}>{t(motherMenu)}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {t(activeMenu)}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default PageTitle;
